/**
 * Utility Functions
 *
 * Common utility functions used throughout the application.
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes with proper conflict resolution
 *
 * This utility combines clsx (for conditional classes) with tailwind-merge
 * (for resolving Tailwind class conflicts). This ensures that when you have
 * conflicting classes like 'px-2' and 'px-4', only the last one is applied.
 *
 * @example
 * cn('px-2', 'px-4') // => 'px-4'
 * cn('px-2', condition && 'px-4') // => 'px-4' if condition is true
 * cn('text-red-500', 'hover:text-blue-500') // => 'text-red-500 hover:text-blue-500'
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
